var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { VelocityComponent } from 'velocity-react';
var Animate = function (props) {
    var children = React.cloneElement(props.children, {
        style: __assign(__assign({}, props.children.style), { visibility: 'hidden' }),
    });
    return React.createElement(VelocityComponent, __assign({}, props, { children: children }));
};
Animate.defaultProps = {
    animation: 'transition.fadeIn',
    runOnMount: true,
    targetQuerySelector: null,
    interruptBehavior: 'stop',
    visibility: 'visible',
    duration: 300,
    delay: 50,
    easing: [0.4, 0.0, 0.2, 1],
    display: null,
};
export default Animate;



//////////////////
// WEBPACK FOOTER
// ./src/theme/components/Animate.tsx
// module id = 194
// module chunks = 81